<template>
  <div class="tostart text-no">
    <!--  头部 -->
    <div class="head df">
      <div class="head-l df">
        <el-select
          v-model="RangeValue"
          placeholder="全部"
          size="small"
          @change="RangeSearch"
          style="margin-right: 40px"
        >
          <el-option
            v-for="item in array"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="value"
          placeholder="最近1个月"
          size="small"
          @change="TimeRangeSearch"
        >
          <el-option
            v-for="item in options"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-popover placement="bottom" width="212" trigger="click">
          <div class="issue-hint">
            <p style="padding-bottom: 3px">
              本期账单发票，需本期账单需确认后，才能开具。确认路径：
            </p>
            <a href="/"
              ><div class="bgc-blue" style="text-decoration: underline">
                账单>本期账单>确认账单
              </div></a
            >
            <!-- <p style="padding-top: 10px">
              若确认后仍未找到请联系对账会计：{{AccountingPhone}}
            </p> -->
          </div>
          <!-- @click="AccountingPhoneRequest" -->
          <div class="hint pointer" slot="reference">本期发票未找到？</div>
        </el-popover>
      </div>
      <div class="head-r fr df">
        <div class="money">开票金额：<span>￥</span></div>
        <div v-if="!ToInvoice" class="invoiceds df">
          <div class="money-input">
            <el-input
              size="small"
              placeholder="0.00"
              @blur="valueJudgment"
              show-word-limit
              disabled
            ></el-input>
          </div>
          <el-button type="primary" size="small" disabled>开具发票</el-button>
          <el-popover placement="bottom" width="206" trigger="click">
            <span class="issue-hint">需勾先选账单再进行开票操作</span>
            <div slot="reference" class="ts"></div>
          </el-popover>
        </div>
        <div v-else class="invoiced df">
          <div class="money-input">
            <el-input
              type="text"
              v-model="money"
              size="small"
              placeholder="0.00"
              @blur="valueJudgment"
              @input="inputMoney"
            ></el-input>
          </div>
          <!-- :disabled='ToInvoice' -->
          <el-button type="primary" size="small" @click="invoiceds"
            >开具发票</el-button
          >
        </div>
      </div>
    </div>
    <!-- list -->
    <div v-if="ISshow" class="pastRecordsmain">
      <div class="item">
        <div class="list pointer" v-for="(item, key) in info" :key="key">
          <div
            class="list-box"
            :class="item.checks ? 'bgc' : 'bgc2'"
            @click="checkbox(item, key)"
          >
            <div>
              <div class="checks fl issue-hint">
                <el-checkbox
                  :value="item.checks"
                  @change="checkbox(item, key)"
                ></el-checkbox>
                可开票（元）
              </div>
            </div>

            <div class="row df">
              <div class="invoice-amount">
                <span class="invoice-amount-integer"
                  ><span v-if="item.unInvoiceMoney1.length < 4">￥</span
                  >{{ item.unInvoiceMoney1 }}</span
                >
                <span
                  v-if="item.unInvoiceMoney2"
                  class="invoice-amount-decimals"
                  style="font-size: 14px; font-weight: 600"
                  >.{{ item.unInvoiceMoney2 }}</span
                >
                <span
                  v-else
                  class="invoice-amount-decimals"
                  style="font-size: 14px; font-weight: 600"
                  >.00</span
                >
              </div>
              <div class="Amount-invoiced">已开票：{{ item.invoiceMoney }}</div>
            </div>
            <div
              style="text-align: left; margin: 8px 0 5px 0"
              title="点击复制对账单号"
              @click.stop="copy(item.statBillNo)"
            >
              <span>对账单号：</span>
              <span style="font-size: 13px">{{ item.statBillNo }}</span>
            </div>
            <div style="text-align: left; margin: 8px 0 5px 0">
              <span>境内金额：</span>
              <span style="font-size: 13px">{{
                item.domesticUnInvoiceMoney
              }}</span>
            </div>
            <div style="text-align: left; margin: 8px 0 5px 0">
              <span>境外金额：</span>
              <span style="font-size: 13px">{{
                item.outLandsUnInvoiceMoney
              }}</span>
            </div>
            <div class="row df gray-word Payment-days-time">
              <div>账期：</div>
              <div class="Payment-days">
                {{
                  item.billStartDetail
                    ? $moment(item.billStartDetail).format("YYYY-MM-DD") +
                      "&nbsp;&nbsp;至&nbsp;&nbsp;"
                    : ""
                }}{{ $moment(item.billEndDetail).format("YYYY-MM-DD") }}
              </div>
            </div>
            <el-button
              type="primary"
              size="mini"
              round
              style="float: right"
              v-if="item.status == 'un_confirm'"
              @click.stop="ConfirmLongBill(item.statBillNo)"
              >确认账单</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="bottom fl" v-if="total > 8">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currpage"
        :page-sizes="[8, 16, 32]"
        :page-size="pagesize"
        layout="total,prev, pager, next, sizes,jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 抽屉 -->
    <el-radio-group v-model="direction"> </el-radio-group>
    <el-drawer
      custom-class="drawer-BOX"
      title="发票设置"
      :visible.sync="drawer"
      :direction="direction"
      :page-sizes="[5, 16, 32]"
      :page-size="pagesize"
      :before-close="handleClose"
      :wrapperClosable="false"
    >
      <!-- 开票信息 -->
      <div class="invoice-information-box">
        <el-form ref="form" :model="form">
          <!-- 销货清单 -->
          <div>
            <signboard :signboardName="anchorNav[0].name"></signboard>
            <div class="account-sales">
              <el-checkbox v-model="isPrintSaleList"
                ><span style="color: rgba(0, 0, 0, 0.88)"
                  >需要销货清单</span
                ></el-checkbox
              >
            </div>
          </div>
          <!-- 开票资料 -->
          <signboard :signboardName="anchorNav[1].name"></signboard>
          <div class="invoice-information">
            <el-form-item label="发票类型：">
              <el-radio-group v-model="billCategory">
                <el-radio
                  @change="invoiceType(billCategory)"
                  v-model="billCategory"
                  label="01"
                  style="color: rgba(0, 0, 0, 0.88)"
                  >电子专票</el-radio
                >
                <el-radio
                  @change="invoiceType(billCategory)"
                  v-model="billCategory"
                  label="06"
                  style="color: rgba(0, 0, 0, 0.88)"
                  >电子普票</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="客户类型：" required>
              <el-select
                @change="PayableToTheName"
                v-model="billTitle"
                size="mini"
                placeholder="抬头名称与签订合同名称需保持一致"
              >
                <div v-for="(item, key) in forms" :key="key">
                  <el-option :label="item.billTitle" :value="key">企业</el-option>
                  <el-option :label="item.billTitle" :value="key">个人</el-option>
                </div>
              </el-select>
            </el-form-item> -->
            <el-form-item label="抬头名称：" required>
              <el-select
                @change="PayableToTheName"
                v-model="billTitle"
                size="mini"
                placeholder="抬头名称与签订合同名称需保持一致"
              >
                <div v-for="(item, key) in forms" :key="key">
                  <el-option :label="item.billTitle" :value="key">{{
                    item.billTitle
                  }}</el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="纳税人识别号：" :required="billCategory == '01'">
              <el-input
                v-model="taxId"
                disabled
                placeholder="请填写纳税人识别号"
                size="mini"
              ></el-input>
            </el-form-item>
            <!-- 电子发票 -->
            <el-collapse-transition v-if="billCategory == '06'">
              <div class="Issue-number" v-if="boxshow">
                <el-form-item
                  label="银行账户："
                >
                  <el-input
                    v-model="bankNumber"
                    disabled
                    placeholder="请填写银行账号"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="开户银行："
                >
                  <el-input
                    v-model="bankName"
                    disabled
                    placeholder="请填写开户银行"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="联系电话："
                >
                  <el-input
                    v-model="regTel"
                    disabled
                    placeholder="请填写注册电话"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="纳税人地址："
                >
                  <el-input
                    v-model="regAddress"
                    disabled
                    placeholder="请填写纳税人地址"
                    size="mini"
                  ></el-input>
                  <!-- <el-collapse-transition v-if="billCategory == '01'"> -->
                </el-form-item>
                <el-form-item label="数量：">
                  <el-input
                    v-model="no"
                    placeholder="请输入…可保留小数点后2位"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item label="单位：">
                  <el-input
                    v-model="unit"
                    placeholder="请输入…最多8个汉字"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item label="规格型号：" class="top">
                  <el-input
                    type="textarea"
                    placeholder="请输入…最多22个汉字"
                    maxlength="22"
                    show-word-limit
                    v-model="standardType"
                  ></el-input>
                </el-form-item>
                <el-form-item label="备注：" class="top">
                  <el-input
                    type="textarea"
                    placeholder="请输入…最多92个汉字"
                    maxlength="92"
                    show-word-limit
                    v-model="remark"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- </el-collapse-transition> -->
            </el-collapse-transition>
            <!-- 增值税发票 -->
            <div v-if="billCategory == '01'">
              <!-- <el-form-item label="银行账户：" :required="billCategory == '01'"> -->
                <el-form-item label="银行账户：">
                <el-input
                  v-model="bankNumber"
                  disabled
                  placeholder="请填写银行账号"
                  size="mini"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="开户银行：" :required="billCategory == '01'"> -->
                <el-form-item label="开户银行：">
                <el-input
                  v-model="bankName"
                  disabled
                  placeholder="请填写开户银行"
                  size="mini"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="联系电话：" :required="billCategory == '01'"> -->
                <el-form-item label="联系电话：">
                <el-input
                  v-model="regTel"
                  disabled
                  placeholder="请填写注册电话"
                  size="mini"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="纳税人地址：" :required="billCategory == '01'"> -->
                <el-form-item label="纳税人地址：">
                <el-input
                  v-model="regAddress"
                  disabled
                  placeholder="请填写纳税人地址"
                  size="mini"
                ></el-input>
                <!-- <el-collapse-transition > -->
              </el-form-item>
            </div>
            <!-- 专票 -->
            <el-collapse-transition v-if="billCategory == '01'">
              <div class="Issue-numbers" v-if="boxshow">
                <el-form-item label="数量：">
                  <el-input
                    v-model="no"
                    placeholder="请输入…可保留小数点后2位"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item label="单位：">
                  <el-input
                    v-model="unit"
                    placeholder="请输入…最多8个汉字"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item label="规格型号：" class="top">
                  <el-input
                    type="textarea"
                    placeholder="请输入…最多22个汉字"
                    maxlength="22"
                    show-word-limit
                    v-model="standardType"
                  ></el-input>
                </el-form-item>
                <el-form-item label="备注：" class="top">
                  <el-input
                    type="textarea"
                    placeholder="请输入…最多92个汉字"
                    maxlength="92"
                    show-word-limit
                    v-model="remark"
                  ></el-input>
                </el-form-item>
              </div>
            </el-collapse-transition>
            <div class="collect-unfold text-no" @click="boxshow = !boxshow">
              <div>{{ !boxshow ? "展开非必填项" : "收起非必填项" }}</div>
              <img
                :class="boxshow ? '' : 'rotate'"
                src="../../../assets/picture/collect-unfold.png"
                alt=""
              />
            </div>
          </div>
          <!-- 收票人信息 -->
          <signboard :signboardName="anchorNav[2].name"></signboard>
          <!-- 电子普票 -->
          <!-- <div v-if="billCategory == '06'"> -->
            <div>
            <el-form-item label="收票人邮箱：" required>
              <el-input
                v-model="email"
                placeholder="请填写邮箱"
                size="mini"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 增值稅纸质专票 -->
          <!-- <div v-if="billCategory == '01'">
            <el-form-item label="收票人姓名：" required>
              <el-input
                v-model="customerSendInfoList.acceptCustomer"
                placeholder="请填写收票人姓名"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="收票人电话：" required>
              <el-input
                v-model="customerSendInfoList.telephone"
                placeholder="请填写收票人电话"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item class="arealist" label="收票人地址：" required>
              <div
                class="select-address text-hidden pointer"
                @click="areaFocus"
              >
                {{ customerSendInfoList.provinces }}
              </div>
              <van-area
                v-show="areaShow"
                title="选择省市区"
                :area-list="areaList"
                @cancel="areaCancel"
                @confirm="areaConfirm"
              />
            </el-form-item>
            <el-form-item label="" required>
              <el-input
                v-model="detailsAddress"
                placeholder="请输入详细地址"
                size="mini"
              ></el-input>
            </el-form-item>
          </div> -->
        </el-form>
        <div class="btn">
          <el-button size="small" @click="drawer = false">暂不开票</el-button>
          &nbsp;&nbsp;
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="Loading"
            >开具发票</el-button
          >
        </div>
      </div>
    </el-drawer>
    <!-- 发票预览 -->
    <el-dialog
      title="增值税专用发票-发票预览-(预览发票仅供参考)"
      :visible.sync="visible"
      width="70%"
    >
      <Tableinvoice :obj="InvoicePreviewList" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="Loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <noContent
      style="padding-top: 84px"
      v-if="!ISshow"
      img="1"
      explain="没有可开的发票"
    ></noContent>
    <!-- 账单确认弹窗 -->
    <el-dialog
      title="确认账单"
      :visible.sync="isConfirmLongBill"
      width="30%"
      :before-close="ConfirmhandleClose"
    >
      <span>{{ ListString(ConfirmLongBillList) }}</span>
      <div>您的这些账单还未确认,是否去确认?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isConfirmLongBill = false">取 消</el-button>
        <el-button type="primary" @click="ConfirmList">去确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import signboard from "@/components/signboard";
import noContent from "@/components/noContent";
import Tableinvoice from "@/components/Tableinvoice";
import API from "../../../api/invoice";
// import API from "../../../api/bill";
const api = new API();
export default {
  components: { signboard, noContent, Tableinvoice },
  data() {
    return {
      AccountingPhone: "95353", //会计电话
      areaList,
      Loading: false,
      thisQueryKey: "",
      areaShow: false, // 省市区 显隐
      detailsAddress: "", // 专票详情地址
      customerSendInfoList: {},
      visible: false,
      // customerEmaile: "",
      isConfirmLongBill: false,
      ConfirmLongBillList: [],
      billTitle: "",
      billCategory: "01",
      ISshow: true,
      total: 0,
      timeRange: "1",
      Range: "ALL",
      ToInvoice: false,
      drawer: false,
      direction: "rtl",
      // InvoiceNumber: [],
      // currentPage: 1,
      pagesize: 8, //每页的数据条数
      currpage: 1, //默认开始页面
      money: "",
      value: "",
      RangeValue: "",
      options: [
        { value: "1", label: "最近1个月" },
        { value: "3", label: "最近3个月" },
        { value: "6", label: "最近半年" },
        { value: "12", label: "最近1年" },
      ],
      tableDatas: [],
      info: [],
      //抽屉
      anchorNav: [
        { name: "销货清单", href: "#a" },
        { name: "开票资料", href: "#b" },
        { name: "收票人信息", href: "#c" },
      ],
      array: [
        {
          label: "全部业务",
          value: "ALL",
        },
        {
          label: "快递业务",
          value: "PKG",
        },
        {
          label: "零担业务",
          value: "LTL",
        },
        {
          label: "整车业务",
          value: "FTL",
        },
        {
          label: "仓储业务",
          value: "WAH",
        },
      ],

      boxshow: false,
      // invoiceBaseMessage:{
      totalAmount: "",
      acceptName_k: this.billTitle, //this.billTitle,
      taxId: "", //this.form.taxId,
      bankName: "", //开户银行
      bankNumber: "", //银行账号,
      regAddress: "", //注册地址,
      regTel: "", // 注册电话,
      billAmount: this.money, //this.money,
      billType: this.billCategory, //this.billCategory,
      unit: "", //单位,
      no: "", //数量,
      standardType: "", // tt,//规格型号,
      remark: "", // 备注,
      acceptCustomer: "", // 收货人,
      acceptPhone: "", // 收货人电话,
      acceptAddress: "", // tt ,//收货人地址,
      email: "", //邮箱,
      InvoicePreviewList: {},
      // },
      form: {},
      forms: {},
      isPrintSaleList: false,
    };
  },
  watch: {},
  methods: {
    copy(data) {
      // 点击复制运单号
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },
    async Invoicing() {
      let statementNoList = [];
      this.info.forEach((v) => {
        if (v.checks) {
          statementNoList.push(v.statBillNo);
        }
      });
      let res = await api.privewInvoice({ statementNoList });
      console.log(res.data);
      if (res.data.length !== 0) {
        this.InvoicePreviewList = res.data[0];
        this.InvoicePreviewList.billTitle = this.billTitle;
        this.InvoicePreviewList.taxId = this.taxId;
        this.InvoicePreviewList.bankNumber = this.bankNumber;
        this.InvoicePreviewList.bankName = this.bankName;
        this.InvoicePreviewList.regTel = this.regTel;
        this.InvoicePreviewList.regAddress = this.regAddress;
        this.InvoicePreviewList.no = this.no;
        this.InvoicePreviewList.unit = this.unit;
        this.InvoicePreviewList.standardType = this.standardType;
        this.InvoicePreviewList.remark = this.remark;
        this.InvoicePreviewList.money = this.money;
        this.visible = true;
      } else {
        this.onSubmit();
      }
    },
    isshowMore(item, key) {
      if (key !== this.listKye) {
        this.info.forEach((item) => {
          item.more = false;
        });
        const list = JSON.parse(JSON.stringify(this.info));
        this.info = [];
        this.info = list;
      }
      this.info[key].more = !item.more;

      this.listKye = key;
      // let temporary = this.info
      // this.info = []
      // this.info = temporary
    },
    inputMoney() {
      if (this.money - 0 > 100000000) {
        this.$message.error("发票金额不能大于一亿元，请重新输入");
        this.AmountOfCalculation();
      }
    },
    areaConfirm(v) {
      this.customerSendInfoList.provinces =
        v[0].name + "|" + v[1].name + "|" + v[2].name;
      // this.form.region = v[0].name+'/'+v[1].name+'/'+v[2].name
      this.detailsAddress = "";
      this.areaShow = false;
    },
    areaCancel() {
      this.areaShow = false;
    },
    areaFocus() {
      this.areaShow = true;
    },
    // 按照时间段搜索待開發票
    TimeRangeSearch(value) {
      this.currpage = 1;
      this.pageSize = 8;
      this.timeRange = value;
      this.queryPageInvoceApplyList();
    },
    // 按照业务类型段搜索待開發票
    RangeSearch(value) {
      this.currpage = 1;
      this.pageSize = 8;
      this.Range = value;
      this.queryPageInvoceApplyList();
    },
    ListString(item) {
      return item.join();
    },
    async ConfirmLongBill(item) {
      let res = await api.invoiceConfirmBillNo({ statementNoList: [item] });
      console.log(res);
      if (res.success) {
        this.queryPageInvoceApplyList();
        this.$forceUpdate();
        return this.$message({
          message: "确认成功",
          type: "success",
        });
      } else {
        return this.$message.error(res.errorMessage);
      }
    },
    async queryPageInvoceApplyList() {
      let parme = {
        invoiceMonth: +this.timeRange,
        currentPage: this.currpage,
        pageSize: this.pagesize,
        businessType: this.Range,
      };
      let res = await api.queryPageInvoceApplyList(parme);
      if (res.length == 0) {
        this.ISshow = false;
      } else {
        this.ISshow = true;
      }
      this.info = [];
      this.info = JSON.parse(JSON.stringify(res.dataList));
      this.total = res.total;
      this.thisQueryKey = res.thisQueryKey;
      if (this.info.length == 0) {
        this.ISshow = false;
      } else {
        this.ISshow = true;
      }
      this.info.forEach((item) => {
        item.more = false;
        item.checks = false;
        item.unInvoiceMoney1 = ("" + item.unInvoiceMoney).split(".")[0];
        item.unInvoiceMoney2 = ("" + item.unInvoiceMoney).split(".")[1];
      });
      this.ToInvoice = false; // =======================================================
      this.money = 0;
    },
    baytlenth(baty) {
      var byteLen = 0;
      for (var i = 0; i < baty.length; i++) {
        if (baty.charCodeAt(i) > 255) {
          byteLen += 2;
        } else {
          byteLen += 1;
        }
      }
      return byteLen;
    },
    onSubmit() {
      // 请求开具发票按钮
      console.log("请求开发票", this.billCategory);
      console.log(this.billCategory, 88888);

      // let baty = this.baytlenth(this.regAddress) + this.baytlenth(this.regTel);
      let bankbaty =
        this.baytlenth(this.bankName) + this.baytlenth(this.bankNumber);
      // let regex = /^[0-9A-Z]{15,20}$/;
      // if (!regex.test(this.taxId)) {
      //   this.$message.error("税号只能填写15-20位字和或数字与大写英文字母组合");
      //   return;
      // }
      if (this.billTitle == "") {
        return this.$message.error("请联系德邦网点维护开票信息。");
      }
      // if (this.billCategory == "06") {
        // if (this.taxId == "" || this.email == "") {
            // if ( this.email == "") {
            //   return this.$message.error("必填信息请填写完整！");
            // }
      // }
      if (this.billCategory == "01") {
        console.log("专票"); // acceptCustomer  收货人acceptPhone 收货人电话   acceptAddress  //收货人地址
        if (
          this.taxId == "" 
          // ||
          // this.bankName == "" ||
          // this.bankNumber == "" ||
          // this.regAddress == "" ||
          // this.regTel == "" ||
          // this.acceptCustomer == "" ||
          // this.acceptPhone == "" 
          // ||
          // this.customerSendInfoList.acceptCustomer == "" ||
          // this.customerSendInfoList.telephone == "" ||
          // this.customerSendInfoList.provinces == "" ||
          // this.detailsAddress == ""
        ) {
          return this.$message.error("必填信息请填写完整！");
        }
        // if (baty > 99) {
        //   return this.$message.error(
        //     "地址与电话不能超过100字符(1个汉字=2个字符)"
        //   );
        // }
        if (bankbaty > 99) {
          return this.$message.error(
            "开户银行和银行账号不能超过100字符(1个汉字=2个字符)"
          );
        }
      }
      this.Loading = true;
      window.setTimeout(() => {
        this.Loading = false;
      }, 5000);
      this.applyInvoiceList();
    },
    //隐藏抽屉
    handleClose() {
      this.drawer = false;
    },
    ConfirmhandleClose() {
      this.isConfirmLongBill = false;
    },
    // 分页 : 选择展示条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.currpage = 1;
      this.queryPageInvoceApplyList();
    },
    // 分页 : 换页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currpage = val;
      this.queryPageInvoceApplyList();
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    valueJudgment() {
      //发票金额修改判断
      //离焦 发票金额判断
      if (
        /^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/.test(
          +this.money
        )
      ) {
        if (+this.money <= 0) {
          this.$message.error("发票金额不能为 0");
          // this.selectPrice = Number(this.options.selectPrice).toFixed(2)
        }
        // if(Number(this.selectPrice) > this.options.selectPrice){
        //   this.$message.error('输入金额不能大于总开票金额');
        //   // this.selectPrice = Number(this.options.selectPrice).toFixed(2)
        //  }
        // if(parseInt(this.selectPrice)==this.selectPrice){
        //  }else {
        if (!/^\d+(\.\d{0,2})?$/.test(+this.money)) {
          console.log(this.money, 111);
          this.$message.error("请保留小数点后两位");
        }
        console.log(+this.money, 222);
        //  }
      } else {
        this.$message.error("请输入正确数字");
        this.money = "";
        //  this.selectPrice = Number(this.options.selectPrice).toFixed(2)
      }
    },
    // 开票金额计算
    AmountOfCalculation() {
      this.money = 0;
      this.totalAmount = 0;
      this.stateNums = [];
      this.info.forEach((item) => {
        if (item.checks) {
          this.stateNums.push(item.statBillNo);
          this.totalAmount += item.unInvoiceMoney;
          this.money += item.unInvoiceMoney;
        }
      });
    },
    checkbox(item, key) {
      //勾选 取消 复选框
      this.info[key].checks = !item.checks;
      this.info.map((i, v) => {
        console.log(v, i.checks);
      });
      this.AmountOfCalculation();
      // if (item.checks) {
      //   this.ToInvoice = true;
      // }
      this.ToInvoice = false;
      this.info.map((i) => {
        if (i.checks) {
          this.ToInvoice = true;
        }
      });

      // this.ToInvoice = a;
    },
    async ConfirmList() {
      let res = await api.invoiceConfirmBillNo({
        statementNoList: this.ConfirmLongBillList,
      });
      console.log(res);
      this.isConfirmLongBill = false;
      if (res.success) {
        this.queryPageInvoceApplyList();
        this.$forceUpdate();
        return this.$message({
          message: "确认成功",
          type: "success",
        });
      } else {
        return this.$message.error(res.errorMessage);
      }
    },
    //开具发票 弹出抽屉
    invoiceds() {
      //开具发票按钮
      if (this.money > this.totalAmount) {
        this.money = this.totalAmount;
        return this.$message.error("输入金额不能大于总开票金额");
      }
      if (this.money <= 0) {
        this.money = this.totalAmount;
        return this.$message({
          showClose: true,
          message: "输入金额不能小于或等于0",
          type: "error",
          offset: 300,
        });
      }
      var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
      if (!reg.test(this.money)) {
        this.money = this.totalAmount;
        return this.$message({
          showClose: true,
          message: "请输入保留两位小数点的正数",
          type: "error",
          offset: 300,
        });
      }
      this.ConfirmLongBillList = [];
      this.info.forEach((v) => {
        if (v.checks && v.status == "un_confirm") {
          this.ConfirmLongBillList.push(v.statBillNo);
          this.isConfirmLongBill = true;
        }
      });
      if (this.isConfirmLongBill == false) {
        this.drawer = true;
      }
      this.Loading = false;
      this.queryCustomerTaxpayerInfo();
      console.log("开具发票按钮");
    },
    invoiceType(label) {
      this.billCategory = label;
      this.queryCustomerTaxpayerInfo();
    },
    PayableToTheName(key) {
      this.form = this.forms[key];
      this.bankName = this.form.bankName;
      this.bankNumber = this.form.bankNumber;
      this.billTitle = this.form.billTitle;
      this.regAddress = this.form.regAddress;
      this.regTel = this.form.regTel;
      this.taxId = this.form.taxId;
      this.billTitle = this.form.billTitle;
    },
    async queryCustomerTaxpayerInfo() {
      let parme = {
        invoiceType: this.billCategory,
      };
      let res = await api.queryCustomerTaxpayerInfo(parme);
      if (res.success) {
        this.form = res.data.taxpayerInfoList[0];
        this.forms = res.data.taxpayerInfoList;
        this.billTitle = res.data.taxpayerInfoList[0].billTitle;
        this.acceptName_k = res.data.taxpayerInfoList[0].billTitle;
        this.regTel = res.data.taxpayerInfoList[0].regTel;
        this.regAddress = res.data.taxpayerInfoList[0].regAddress;
        this.bankNumber = res.data.taxpayerInfoList[0].bankNumber;
        this.bankName = res.data.taxpayerInfoList[0].bankName;
        this.taxId = res.data.taxpayerInfoList[0].taxId;
        if (this.billCategory == "06") {
          this.email = res.data.customerEmaile;
        }
        if (this.billCategory == "01") {
          this.acceptCustomer = res.data.taxpayerInfoList[0].acceptCustomer;
          this.acceptAddress = res.data.taxpayerInfoList[0].address;
          this.acceptPhone = res.data.taxpayerInfoList[0].telephone;
          this.customerSendInfoList = res.data.customerSendInfoList[0];
          //  浙江省|杭州市|下沙区 人民路69号
          if (!this.customerSendInfoList.address) {
            this.customerSendInfoList.provinces = "";
            this.detailsAddress = "";
            return;
          } else {
            let address = this.customerSendInfoList.address;
            address.split("|");
            this.customerSendInfoList.provinces = [
              address.split("|")[0],
              address.split("|")[1],
              address.split("|")[2],
            ].join("|");
            this.detailsAddress = address.split("|")[3];
          }
        }
      }

      console.log(res);
    },
    async applyInvoiceList() {
      // console.log(this.invoiceBaseMessage.bankNumber);
      let temporary = "";
      this.isPrintSaleList ? (temporary = "Y") : (temporary = "N");
      let acceptAddress = "";
      acceptAddress =
        this.customerSendInfoList.provinces + "|" + this.detailsAddress;
      console.log(acceptAddress);
      let parme = {
        queryKey: this.thisQueryKey,
        stateNums: this.stateNums,
        invoiceBaseMessage: {
          totalAmount: this.totalAmount,
          acceptName_k: this.billTitle,
          taxId: this.form.taxId,
          bankName: this.bankName, //开户银行,
          bankNumber: this.bankNumber, //银行账号,
          regAddress: this.regAddress, //注册地址,
          regTel: this.regTel, //注册电话,
          billAmount: "" + this.money,
          billType: this.billCategory,
          unit: this.unit, //单位,
          no: this.no, //数量,
          standardType: this.standardType, //tt,//规格型号,
          remark: this.remark, //备注,
          acceptCustomer: this.customerSendInfoList.acceptCustomer, // 收货人,
          acceptPhone: this.customerSendInfoList.telephone, //收货人电话,
          acceptAddress: acceptAddress, //tt ,//收货人地址,
          email: this.email, //邮箱,
          isPrintSaleList: temporary,
        },
      };
      let res = await api.applyInvoiceList(parme);
      console.log(res);
      if (res.success) {
        this.$message({
          showClose: true,
          message: "申请成功，稍后请至发票管理-开票历史查询！",
          type: "success",
          offset: 300,
        });
        window.setTimeout(() => {
          this.queryPageInvoceApplyList();
          this.drawer = false;
          this.visible = false;
          this.Loading = false;
        }, 3000);
      } else {
        this.Loading = false;
        this.drawer = false;
        this.visible = false;
      }
    },
  },
  created() {
    this.Loading = false;
    this.queryPageInvoceApplyList();
  },
};
</script>

<style lang='less' scoped>
.tostart {
  width: 100%;
  height: 100%;
  font-size: 14px;
  .select-address {
    width: 375px;
    height: 28px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    text-align: left;
    padding: 0 15px;
    line-height: 28px;
    font-size: 13px;
    margin-top: 5px;
    &:hover {
      // color: #008cffff;
      border-color: rgb(200, 192, 192);
    }
  }
  .more {
    padding: 16px;
    text-align: left;
    position: absolute;
    right: 10px;
    top: 110px;
    width: 185px;
    background: #ffffff;
    box-shadow: 0px 9px 20px 0px rgba(102, 139, 204, 0.04);
    border-radius: 4px;
    border: 1px solid #ececec;
    z-index: 2;
    div {
      font-size: 13px;
      margin-top: 4px;
    }
  }
  .value {
    text-align: right;
    word-break: keep-all;
    width: 400rpx;
    overflow-x: scroll;
    white-space: nowrap;
  }
  /deep/.el-drawer__header > :first-child {
    text-align: left;
    font-size: 16px;
    font-weight: 700;
    color: #09090a;
  }
  /deep/.el-form {
    .arealist {
      width: 375px;
      .el-form-item__content {
        position: relative;
        width: 375px;
        .van-area {
          width: 375px;
          height: 300px;
          position: absolute;
          bottom: 46px;
          background-color: #fff;
          z-index: 111111;
          width: 100%;
          box-shadow: 0px 0px 18px #cbcbcbd1;
          border-radius: 5px;
          overflow: hidden;
        }
      }
    }
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #ec151b;
    border-color: #ec151b;
  }
  .head {
    align-items: center;
    justify-content: space-between;
    .head-l {
      align-items: center;
      .hint {
        margin-left: 24px;
        width: 112px;
        color: #008cff;
        text-decoration: underline;
      }
    }
    .head-r {
      height: 32px;
      align-items: center;
      .money-input {
        width: 108px;
        height: 32px;
        margin: 0 24px 0 6px;
      }
      .money {
        color: rgba(0, 0, 0, 0.6);
        span {
          color: #000;
          font-weight: 500;
          font-size: 16px;
        }
      }
      .invoiceds {
        position: relative;
        .ts {
          position: absolute;
          right: 0;
          width: 100px;
          height: 32px;
        }
      }
      /deep/.el-input--small .el-input__inner {
        text-align: right;
      }
    }
  }
  .pastRecordsmain {
    flex: 1;
    overflow: auto;
    padding-bottom: 24px;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 1, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
    }
    .item {
      // overflow: auto;
      display: flex;
      flex-wrap: wrap;
      padding-top: 16px;
      .list {
        max-width: 360px;
        border: 1px solid #ececec;
        position: relative;
        width: 23.5%;
        margin-right: 2%;
        // height: 124px;
        margin-bottom: 32px;
        .list-box {
          width: 100%;
          height: 100%;
          background-color: #fff;
          border-radius: 4px;
          padding: 16px 16px 35px 16px;
        }
        .checks {
          align-items: center;
        }
        .row {
          width: 100%;
          align-items: center;
          .invoice-amount {
            align-items: flex-end;
            margin-top: 5px;
            .invoice-amount-integer {
              font-size: 35px;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.8);
              line-height: 40px;
            }
            .invoice-amount-decimals {
              font-size: 13px;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
            }
          }
          .Amount-invoiced {
            height: 40px;
            padding: 16px 0 0 10px;
          }
        }
        .Payment-days-time {
          padding-top: 10px;
          .Payment-days {
            padding-top: 3px;
          }
        }
      }
      .bgc {
        border: 1px solid #ec151b;
      }
      .bgc2 {
        border: 1px solid #fff;
      }
      .list:nth-child(4n) {
        margin-right: 0;
      }
    }
    .bottom {
      margin-top: 24px;
    }
  }
  /deep/.el-drawer__open .el-drawer.rtl {
    width: 66% !important;
    height: 100%;
  }
  /deep/.el-input.is-disabled .el-input__inner {
    text-align: right;
  }
  /deep/.el-form-item {
    text-align: left;
    padding-left: 23px;
    margin-bottom: 10px;
    .el-form-item__label {
      position: relative;
      width: 120px !important;
    }
    .el-form-item__content {
      margin-left: 120px !important;
    }

    .el-input--mini .el-input__inner {
      text-align: left;
      width: 375px;
    }
    .el-textarea__inner {
      width: 375px;
    }
    .el-textarea__inner {
      height: 76px;
    }
  }
  .invoice-information-box {
    margin-top: -20px;
    padding-bottom: 100px;
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #008cff;
      border-color: #008cff;
    }
    .invoice-information {
      width: 504px;
      .top {
        margin-top: 6px;
      }
      .Issue-number {
        height: 495px;
        width: 520px;
      }
      .Issue-numbers {
        height: 300px;
        width: 520px;
      }
      .rotate {
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
      }
      .collect-unfold {
        display: flex;
        justify-content: center;
        margin-top: 16px;
        cursor: pointer;
        color: #2969ff;
        img {
          width: 20px;
          width: 20px;
          margin-left: 8px;
        }
      }
    }
    .account-sales {
      text-align: left;
      padding-left: 23px;
    }
    /deep/.el-drawer__header > :first-child {
      text-align: left;
      font-size: 16px;
      font-weight: 500;
      color: #09090a;
    }
    .collect-unfold {
      display: flex;
      justify-content: center;
      margin-top: 16px;
      cursor: pointer;
      color: #2969ff;
      img {
        width: 20px;
        width: 20px;
        margin-left: 8px;
      }
    }
    .rotate {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: rotate(180deg);
    }
    .btn {
      width: 66%;
      padding: 16px 0;
      position: fixed;
      bottom: 0;
      background-color: #fff;
    }
  }
}
</style>